import d from "./ghl-ui.es1482.js";
import V from "./ghl-ui.es776.js";
import j from "./ghl-ui.es1255.js";
import y from "./ghl-ui.es777.js";
import c from "./ghl-ui.es784.js";
import g from "./ghl-ui.es418.js";
import O from "./ghl-ui.es419.js";
import C from "./ghl-ui.es410.js";
import M from "./ghl-ui.es421.js";
import P from "./ghl-ui.es763.js";
import w from "./ghl-ui.es403.js";
import x from "./ghl-ui.es1299.js";
import D from "./ghl-ui.es423.js";
import b from "./ghl-ui.es1484.js";
import F from "./ghl-ui.es1307.js";
function U(t, p, o, v, A, l, f) {
  var i = b(t, o), e = b(p, o), s = f.get(e);
  if (s) {
    d(t, o, s);
    return;
  }
  var r = l ? l(i, e, o + "", t, p, f) : void 0, m = r === void 0;
  if (m) {
    var a = O(e), n = !a && M(e), u = !a && !n && D(e);
    r = e, a || n || u ? O(i) ? r = i : C(i) ? r = y(i) : n ? (m = !1, r = V(e, !0)) : u ? (m = !1, r = j(e, !0)) : r = [] : x(e) || g(e) ? (r = i, g(i) ? r = F(i) : (!w(i) || P(i)) && (r = c(e))) : m = !1;
  }
  m && (f.set(e, r), A(r, e, v, l, f), f.delete(e)), d(t, o, r);
}
export {
  U as default
};
